const AREA_LIST = [
  // 多言語対応時の json のキーに使いたいため値を lower camel としてる
  "hokkaidoTohoku",
  "hokushinnetsu",
  "kanto",
  "chubu",
  "kansai",
  "shikokuChugoku",
  "kyushu",
  "others",
] as const;

type Area = (typeof AREA_LIST)[number];
type MasterRecord = {
  code: `${number}`;
  name: Area;
};
type AreaMaster = Record<Area, MasterRecord>;

export const AREA_MASTER = AREA_LIST.reduce<AreaMaster>(
  (previousValue, currentValue, index) => {
    const record: MasterRecord = {
      code: `${index + 1}`,
      name: currentValue,
    };

    previousValue[currentValue] = record;

    return previousValue;
  },
  {} as AreaMaster
);
